module.exports = __webpack_public_path__ + "img/defaultLogo.31c5136c.png";